import { asyncAction } from 'lib/actionCreators'

export const managerProfileView = asyncAction('candidate/MANAGER_PROFILE_VIEW')
